var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "educa_manage_wrap",
      style: "height:" + (_vm.windowHeight - 95) + "px"
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "educa_manage_content" }, [
        _c("div", { staticClass: "school_logo_main" }, [
          _c(
            "div",
            { staticClass: "upload_wrap" },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  attrs: {
                    action: _vm.uploadSrc,
                    "show-file-list": false,
                    accept: ".png",
                    data: _vm.uploadData,
                    headers: _vm.headers,
                    disabled: _vm.isDisabled,
                    "on-progress": _vm.handleAvatarProgress,
                    "on-success": _vm.handleAvatarSuccess,
                    "before-upload": _vm.beforeAvatarUpload
                  },
                  model: {
                    value: _vm.pic,
                    callback: function($$v) {
                      _vm.pic = $$v
                    },
                    expression: "pic"
                  }
                },
                [
                  _vm.pic
                    ? _c("img", {
                        staticClass: "avatar",
                        attrs: { src: _vm.pic }
                      })
                    : _c("i", { class: _vm.uploadIcon })
                ]
              ),
              _vm._v(" "),
              _vm.pic
                ? _c(
                    "div",
                    {
                      staticClass: "upload_delete",
                      on: { click: _vm.deleteUpload }
                    },
                    [_c("i", { staticClass: "el-icon-error" })]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(1)
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "educa_manage_header" }, [
      _c("h2", [_vm._v("学校logo")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "upload_tips" }, [
      _c("p", [_c("i", [_vm._v("*")]), _vm._v("注意：")]),
      _vm._v(" "),
      _c("p", [_vm._v("1.仅支持png格式")]),
      _vm._v(" "),
      _c("p", [_vm._v("2.推荐尺寸：高度40px，长度320px以内")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ae0e522", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ae0e522","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_educa_module/educa/logoManage/schoolLogo.vue
// module id = null
// module chunks = 